import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/tasks',
  component: Management,
  redirect: '/tasks/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/tasks/List'),
      meta: {
        auth: Auth.listTasks
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/tasks/ListTable'),
          meta: {
            auth: Auth.listTasks,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
